import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-8" data-testid="terms-back">
          <ArrowLeft className="h-4 w-4" /> Til forsiden
        </Link>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Juridisk</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-medium tracking-tight text-slate-900" data-testid="terms-title">Vilkår for bruk</h1>
        <p className="mt-3 text-slate-500">Sist oppdatert: {new Date().toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" })}</p>

        <article className="mt-12 prose prose-slate max-w-none space-y-10 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">1. Om tjenesten og leverandør</h2>
            <p className="mt-3">IdeSetGo er en tjeneste levert av <strong>Sammen Fellesskap</strong>, org.nr. <strong>937 196 504</strong> (heretter «IdeSetGo», «vi», «oss»). Ved å bruke tjenesten godtar du disse vilkårene.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">2. Konto og bruk</h2>
            <p className="mt-3">Du må opprette en brukerkonto for å bruke tjenesten. Du er ansvarlig for å holde påloggingsopplysningene dine sikre. Du kan når som helst slette kontoen din ved å kontakte oss på hei@idesetgo.no.</p>
            <p className="mt-3">Tjenesten er beregnet for personer over 18 år eller som representerer en registrert virksomhet.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">3. Priser og betaling</h2>
            <p className="mt-3">Grunnleggende bruk av IdeSetGo (opprette konto, fylle ut spørreskjema, se sammendrag) er gratis. Full tilgang til en generert forretningsplan og PDF-eksport krever en <strong>engangsbetaling på 299 NOK per plan</strong>. IdeSetGo er ikke et abonnement — du betaler kun én gang per plan du ønsker å låse opp.</p>
            <p className="mt-3">Betaling gjennomføres via Stripe. Ved fullført betaling får du umiddelbar tilgang.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">4. Digitalt innhold og angrerett</h2>
            <p className="mt-3">Den fulle forretningsplanen leveres som digitalt innhold umiddelbart etter betaling. I henhold til angrerettloven § 22 bokstav n bortfaller angreretten dersom kunden uttrykkelig samtykker til at leveringen starter før angrefristen utløper og erkjenner at angreretten dermed går tapt.</p>
            <p className="mt-3">Før du betaler må du derfor aktivt bekrefte dette samtykket. Samtykket lagres sammen med ordren og vises i kvitteringen din.</p>
            <p className="mt-3">Ufravikelige forbrukerrettigheter etter norsk lov, som mangelskrav ved feil i tjenesten eller reklamasjon, gjelder uansett fullt ut. Ta kontakt på hei@idesetgo.no dersom du opplever feil.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">5. AI-generert innhold</h2>
            <p className="mt-3">Forretningsplaner genereres av AI-modeller levert av Anthropic basert på informasjonen du oppgir. Innholdet er ment som et utgangspunkt og en veiledning — <strong>ikke som juridisk, finansiell eller regnskapsmessig rådgivning</strong>. Du bør alltid vurdere innholdet kritisk og ved behov konsultere en profesjonell rådgiver.</p>
            <p className="mt-3">Vi garanterer ikke at tallene, markedsestimater eller andre vurderinger i den genererte planen er nøyaktige. Du er selv ansvarlig for å verifisere og tilpasse innholdet.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">6. Immaterielle rettigheter</h2>
            <p className="mt-3">Du eier alt innhold du selv fyller ut. Forretningsplanen som genereres for deg tilhører deg og kan brukes fritt til dine egne formål. Selve plattformen, kode og design tilhører IdeSetGo.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">7. Ansvar</h2>
            <p className="mt-3">IdeSetGo leverer tjenesten «som den er». Vi er ikke ansvarlige for økonomiske eller forretningsmessige beslutninger du tar basert på innholdet i den AI-genererte forretningsplanen, eller for indirekte tap som følger av slike beslutninger.</p>
            <p className="mt-3"><strong>Ingenting i disse vilkårene begrenser ufravikelige rettigheter du har som forbruker etter norsk lov.</strong> Ved feil i tjenesten eller mangler ved leveransen gjelder de lovfestede forbrukerrettighetene fullt ut.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">8. Endringer i vilkårene</h2>
            <p className="mt-3">Vi kan oppdatere disse vilkårene ved behov. Vesentlige endringer varsles på e-post eller ved pålogging. Fortsatt bruk av tjenesten etter en oppdatering utgjør aksept av de nye vilkårene.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">9. Lovvalg og tvister</h2>
            <p className="mt-3">Disse vilkårene reguleres av norsk rett. Er du forbruker og bosatt i Norge, kan tvister som ikke løses i minnelighet bringes inn for din alminnelige verneting i tråd med tvisteloven, og du beholder alle dine rettigheter til å benytte Forbrukertilsynet eller Forbrukerrådet som klageorganer.</p>
          </section>

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-slate-900">10. Kontakt</h2>
            <p className="mt-3">Har du spørsmål? Send oss en e-post på <a href="mailto:hei@idesetgo.no" className="underline text-slate-900">hei@idesetgo.no</a>.</p>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  );
}
